import _styled from "styled-components";
import React from "react";
import { m } from "framer-motion";
import { hasItems } from "~/features/app/utils";
import { graphql } from "~/gql/runtime";
export const graphicStatsGraphicFragment = graphql(`
  fragment GraphicStatsGraphic on statsGraphic_MatrixField {
    ...GraphicStatsGraphicBar
  }
`);
export type GraphicStatsGraphicViewProps<TBar> = {
  bars?: readonly TBar[] | null;
  getBarKey?: (bar: TBar, index: number) => React.Key;
  renderBar: (bar: TBar, index: number, reveal: boolean) => React.ReactNode;
};
export function GraphicStatsGraphicView<TBar>({
  bars,
  getBarKey,
  renderBar
}: GraphicStatsGraphicViewProps<TBar>) {
  const [isInView, setIsInView] = React.useState(false);
  if (!hasItems(bars)) {
    return null;
  }
  return <_StyledMDiv onViewportEnter={() => setIsInView(true)}>
      {bars.map((bar, index) => <React.Fragment key={getBarKey?.(bar, index) || index}>{renderBar(bar, index, isInView)}</React.Fragment>)}
    </_StyledMDiv>;
}
var _StyledMDiv = /*#__PURE__*/_styled(m.div).withConfig({
  displayName: "graphic___StyledMDiv",
  componentId: "sc-14gw0gg-0"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.8rem"
});